<script setup lang="ts">
  import { Link } from "@/components/ui/link"

  const { to, label, disabled } = defineProps<{
    to: string
    label: string
    disabled?: boolean
  }>()
</script>

<template>
  <li
    class="flex border-b-2 border-secondary-300 px-2 py-4 text-secondary-700 dark:border-secondary-500 dark:text-secondary-100"
    :data-testid="`${label}-mobile-nav-item`"
  >
    <span
      v-if="disabled"
      aria-disabled="true"
      class="cursor-not-allowed text-lg font-medium text-secondary-400"
    >
      {{ label }}
    </span>
    <Link v-else :to="to" class="w-full text-lg font-medium">
      {{ label }}
    </Link>
  </li>
</template>
